import { render, staticRenderFns } from "./ProductSales.vue?vue&type=template&id=4f2518ca&scoped=true&"
import script from "./ProductSales.vue?vue&type=script&lang=js&"
export * from "./ProductSales.vue?vue&type=script&lang=js&"
import style0 from "./ProductSales.vue?vue&type=style&index=0&id=4f2518ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2518ca",
  null
  
)

export default component.exports